export default __webpack_public_path__ + "static/media/gastroenterology_and_hepatology.d02a47c0.png";